export default __webpack_public_path__ + "static/media/questions.8393388a.svg";